"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSeoCleanLocationSubDirectoryPrefix = void 0;
var react_1 = require("react");
var useSeoCleanLocationSubDirectoryPrefix = function (address, locationPathName, isChangedSeoCleanLocationSubDirectoryPrefix) {
    return react_1.useMemo(function () {
        if (address &&
            location.pathname.search(address) &&
            (address === null || address === void 0 ? void 0 : address.search('H')) === -1 &&
            (address === null || address === void 0 ? void 0 : address.search('C')) === -1 &&
            (address === null || address === void 0 ? void 0 : address.search('B')) === -1) {
            var seoURL = location.pathname
                .split('/' + locationPathName)[1]
                .split(address);
            return seoURL[0].split('/')[1];
        }
        return '';
    }, [
        locationPathName,
        address,
        isChangedSeoCleanLocationSubDirectoryPrefix,
    ]);
};
exports.useSeoCleanLocationSubDirectoryPrefix = useSeoCleanLocationSubDirectoryPrefix;
